import type { ReactNode } from 'react';

import { Content, EmptyState, Heading } from '@infinex/ui/components';

interface AssetEmptyStateProps {
  /**
   * The image source to display
   */
  imgSrc: string;

  /**
   * The title text to display
   */
  title: string;

  /**
   * Optional description text to display below the title
   */
  description: string | ReactNode;

  /**
   * Optional action element,
   * supports LinkButtonContext that provides default prominence="low" and size="small".
   */
  actionElement?: ReactNode;
}

export function AssetEmptyState({
  imgSrc,
  title,
  description,
  actionElement,
}: AssetEmptyStateProps) {
  return (
    <EmptyState size="small">
      <img src={imgSrc} className="max-h-40 max-w-full" alt="" />

      <Heading slot="title">{title}</Heading>

      <Content className="max-w-xs">
        {description && <span className="max-w-full">{description}</span>}
      </Content>

      {actionElement && actionElement}
    </EmptyState>
  );
}
